import { Combobox } from '@/global/components/Combobox'
import React, { useEffect } from 'react'
import { Local, local } from 'service/api'
import { useStore } from 'store'
import { SelectProps } from './types'

export const SelectLocal: React.FC<SelectProps> = ({
    size = 'small',
    variant = 'filled',
    width,
    disabled,
    className,
}) => {
    const companyId = useStore(state => state.companyId)
    const { data = [], isFetching } = local.useFetch({
        queryParams: { empresaId: companyId },
    })

    const locationId = useStore(state => state.locationId)
    const setLocationId = useStore(state => state.setLocationId)

    useEffect(() => {
        if (locationId > 0 && !data.some(item => item.id === locationId)) {
            setLocationId(-1)
        }
    }, [data, locationId, setLocationId])

    const selectedLocal = data.find(item => item.id === locationId) ?? null

    return (
        <div style={{ width }} className={className}>
            <Combobox<Local>
                label="Local"
                size={size}
                variant={variant === 'outlined' ? 'outlined' : 'filled'}
                placeholder="Selecione um local"
                options={data}
                value={selectedLocal}
                onChange={value => setLocationId(value?.id ?? -1)}
                getOptionLabel={option => option?.nomeLocal || ''}
                getOptionKey={option => String(option.id)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={isFetching}
                noOptionsText="Não há locais cadastrados"
                disabled={disabled}
            />
        </div>
    )
}
